'use client';

import { Button, Typography } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { forwardRef } from 'react';

import { images } from '~/landing/assets';

const links = {
  appStore:
    'https://apps.apple.com/fr/app/cagnup-%C3%A9pargnez-sans-effort/id6743074739',
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.cagnotte.garance&hl=fr',
  learnMore: 'https://www.garance.com/conseils/epargne/cagnup',
};

export const CtaSection = forwardRef<HTMLDivElement>((_, ref) => {
  const t = useTranslations('landing.cagnup.ctaSection');

  return (
    <section ref={ref} className="bg-[#D1FAE5] py-16">
      <div className="mx-auto w-full max-w-screen-2xl space-y-6 px-4 md:px-10">
        <div className="w-full overflow-hidden rounded-xl bg-white">
          <div className="grid grid-cols-1 md:grid-cols-12">
            <div className="relative col-span-full h-64 md:col-span-5 md:h-auto">
              <Image
                fill
                priority
                alt=""
                className="object-cover"
                src={images.cagnup.cta}
              />
            </div>

            <div className="col-span-full flex flex-col justify-center bg-primary px-4 py-12 text-center md:col-span-7 md:px-16 md:text-left">
              <Typography
                className="font-primary mb-4 text-white"
                variant="title-3"
              >
                {t('title')}
              </Typography>

              <Typography className="text-white" variant="title-6">
                {t('description')}
              </Typography>

              <div className="my-6 flex flex-wrap items-center justify-center gap-3.5 md:justify-start">
                <a
                  aria-label={t('appStore')}
                  className="inline-block"
                  href={links.appStore}
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="App Store"
                    height={34}
                    quality={100}
                    src={images.cagnup.appStore}
                    width={146}
                  />
                </a>

                <a
                  aria-label={t('googlePlay')}
                  className="inline-block"
                  href={links.googlePlay}
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="Google Play"
                    height={48}
                    quality={100}
                    src={images.cagnup.googlePlay}
                    width={146}
                  />
                </a>
              </div>

              <div>
                <Button asChild variant="secondary">
                  <a href={links.learnMore} rel="noreferrer" target="_blank">
                    {t('cta')}
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

CtaSection.displayName = 'CtaSection';
